import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { PagesService } from 'src/app/pages/pages.service';

const API_USERS_URL = `${environment.apiUrl}`;

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(private http: HttpClient, private appService: PagesService) {}

  headers = new HttpHeaders()
    .set('accept', 'application/json')
    .set('content-type', 'application/json');

  // public methods
  login(phone: string, password: string, role: string): Observable<any> {
    return this.http.post<any>(
      `${API_USERS_URL}/login/as/admin`,
      {
        phone,
        password,
        role,
      },
      { headers: this.headers }
    );
  }

  // CREATE =>  POST: add a new user to the server
  // createUser(user: any): Observable<any> {
  //   return this.http.post<any>(
  //     `${API_USERS_URL}/register`,
  //     {
  //       name: user.name,
  //       phone: user.phone,
  //       email: user.email,
  //       password: user.password,
  //       password_confirmation: user.password_confirmation,
  //       fcm_token: user.fcm_token,
  //     },
  //     {
  //       headers: this.headers,
  //     }
  //   );
  // }

  // Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
  forgotPassword(email: string): Observable<boolean> {
    return this.http.post<any>(
      `${API_USERS_URL}/forgot-password`,
      {
        email,
      },
      { headers: this.headers }
    );
  }

  changePassword(requestBody: {}): Observable<boolean> {
    return this.http.post<any>(
      `${API_USERS_URL}/change-password`,
      requestBody,
      { headers: this.appService.httpHeaders }
    );
  }
  resetPassword(user: any): Observable<boolean> {
    return this.http.post<any>(
      `${API_USERS_URL}/reset-password`,
      {
        email: user.email,
        password: user.password,
        password_confirmation: user.password_confirmation,
        key: user.reset_key,
      },
      { headers: this.headers }
    );
  }

  getUserByToken(token: string): Observable<any> {
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get<any>(`${API_USERS_URL}/my-info`, {
      headers: httpHeaders,
    });
  }
}
